import { objectEntries } from 'lib/object/objectUtils'
import { css, RuleSet } from 'styled-components'
import { ResponsiveClassNameGetter } from './createResponsiveClassNameGetter'

function getResponsiveStyles<Value extends string | number>(
  responsiveClassNameGetter: ResponsiveClassNameGetter<Value>,
  styleDefinitions: Record<Value, RuleSet<object>>,
): {
  base: RuleSet<object>,
  tablet: RuleSet<object>,
  desktop: RuleSet<object>,
} {
  const base = objectEntries(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter(value as Value)} { ${style as RuleSet<object>} }
  `)
  const tablet = objectEntries(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter(undefined, value as Value)} { ${style as RuleSet<object>} }
  `)
  const desktop = objectEntries(styleDefinitions).map(([value, style]) => css`
    &.${responsiveClassNameGetter(undefined, undefined, value as Value)} { ${style as RuleSet<object>} }
  `)
  return { base, tablet, desktop }
}

export default getResponsiveStyles
